import React from "react";
import QRCode from "react-qr-code";
import styles from "./qr.module.scss";

export default function QrComponent({ value, close }) {
  return (
    <div className={styles.qrContainer} onClick={() => close()}>
      <QRCode
        size={256}
        style={{ height: "100%", maxWidth: "100%", width: "100%" }}
        value={value}
        viewBox={`0 0 256 256`}
      />
    </div>
  );
}
